import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';

const positiveAmountPaymentStatusOptions = [
    { id: "PAYMENT_TO_CUSTOMER_ARRANGED", label: getStatusDescriptionFromStatusValue('PAYMENT_TO_CUSTOMER_ARRANGED') },
    { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }
];
const negativeAmountPaymentStatusOptions = [
    { id: "PAYMENT_TO_HP_ARRANGED", label: getStatusDescriptionFromStatusValue('PAYMENT_TO_HP_ARRANGED') },
    { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }
];

export default function indirectFinancialsColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId + "|" + order.paymentStatus + "|" + index;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            let columnValue = null;
            let clickHandler = null;
            let columnValueData = null;
            let importantData = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "orderId" && order.orderId) {
                    columnValue = order.orderId;
                }
                else if (columnId === "orderType") {
                    columnValue = getOrderTypeText(order.orderType) || "";
                }
                else if (columnId === "company") {
                    columnValue = order.company || "";
                }
                else if (columnId === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(order.collectionDate) || "";
                }
                else if (columnId === "customerAmount") {
                    columnValue = order.customerAmount == null || order.customerAmount == undefined ? 0 : order.customerAmount;
                    importantData = order.customerAmount < 0 ? "NegativeAmount" : "";
                }
                else if (columnId === "currencyCode") {
                    columnValue = order.currencyCode || "";
                }
            }
            else if (columnDataType === "select") {
                if (columnId === "paymentStatus") {
                    columnValue = order.paymentStatus || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: order.paymentStatus, label: getStatusDescriptionFromStatusValue(order.paymentStatus) }];
                    if (order.paymentStatus !== 'COMPLETED') {
                        let paymentStatusDropDownOptions = [];
                        if (order.customerAmount > 0) {
                            if (order.paymentType === 'DRV Net Payment' || order.paymentType === 'HP Payment + HP2B' || order.paymentStatus === 'PAYMENT_TO_CUSTOMER_ARRANGED') {
                                paymentStatusDropDownOptions = [{ id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }];
                            }
                            else {
                                paymentStatusDropDownOptions = positiveAmountPaymentStatusOptions;
                            }
                        }
                        else {
                            if (order.paymentType === 'DRV Net Payment' || order.paymentType === 'HP Payment + HP2B' || order.paymentStatus === 'PAYMENT_TO_HP_ARRANGED') {
                                paymentStatusDropDownOptions = [{ id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }];
                            }
                            else {
                                paymentStatusDropDownOptions = negativeAmountPaymentStatusOptions;
                            }
                        }
                        columnValueData.options = [...columnValueData.options, ...paymentStatusDropDownOptions];
                    }
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                }
            }
            else if (columnDataType === "input") {
                columnValueData = { ...column.data };
                clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                if (columnId === "paymentDate") {
                    columnValue = order.paymentDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [order.createdDate, order.collectionDate, new Date()]
                }
            }
            else if (columnDataType === "globalInvoice") {
                if (column.id === "paymentInstruction") {
                    columnValue = "download";
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                    if (order.customerAmount === 0) {
                        columnValue = "";
                        columnDataType = "string";
                    } else {
                        columnValue = "download"
                    }

                    if (order.paymentType === "HP Credit Value" && order.customerAmount > 0) {
                        isDisabled = true;
                    }
                }
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    disabledCell: isDisabled,
                    clickHandler: clickHandler,
                    importantData: importantData,
                    showInMobileViewAs: column.showInMobileViewAs,
                    isGlobal: order.paymentStatus === "SERVICE_PAYMENT_TO_HP_PENDING" && order.paymentType === "HP Payment + HP2B" ? true : false
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}

